import request from '@/utils/request';

/*************************优惠券*********************************/
export function parkinglotCouponListApi(params) {
  return request({
    url: '/admin/parkinglot/coupon/list',
    method: 'get',
    params: params
  });
}
export function parkinglotCouponInfoApi(params) {
  return request({
    url: '/admin/parkinglot/coupon/info',
    method: 'get',
    params: params
  });
}
export function parkinglotCouponSaveApi(params) {
  return request({
    url: '/admin/parkinglot/coupon/save',
    method: 'post',
    data: params
  });
}
export function parkinglotCouponUpdateApi(params) {
  return request({
    url: '/admin/parkinglot/coupon/update',
    method: 'post',
    data: params
  });
}
export function parkinglotCouponDeleteApi(params) {
  return request({
    url: '/admin/parkinglot/coupon/delete',
    method: 'post',
    params: params
  });
}
export function parkinglotCouponUpdateStatusApi(params) {
  return request({
    url: '/admin/parkinglot/coupon/status',
    method: 'post',
    params: params
  });
}

/*************************优惠券日志*********************************/
export function parkinglotCouponLogListApi(params) {
  return request({
    url: '/admin/parkinglot/coupon/user/list',
    method: 'get',
    params: params
  });
}
export function parkinglotCouponLogListExportApi(params) {
  return request({
    url: "/admin/export/excel/exportParkinglotCouponUser",
    method: 'get',
    params: params
  });
}

/*************************停车场订单日志*********************************/
export function parkinglotOrderListApi(params) {
  return request({
    url: '/admin/parkinglot/order/list',
    method: 'get',
    params: params
  });
}
export function parkinglotOrderListExportApi(params) {
  return request({
    url: "/admin/export/excel/exportParkinglotOrder",
    method: 'get',
    params: params
  });
}